import { useFeeStore } from '@/store/useFeeStore';

/**
 * Hook that provides a function to manually initialize fees.
 * This should be called after user authentication to ensure
 * the API call has proper authorization.
 */
export function useFeeInitializer() {
  const { fetchFixedFeeAmount, isInitialized, isLoading } = useFeeStore();

  // Return the initialization function instead of auto-executing
  return {
    initializeFees: fetchFixedFeeAmount,
    isInitialized,
    isLoading,
  };
}
